// @flow strict

import * as React from 'react';
// import type { ResourceType } from '../types';
import PageContentBlock from '../../../../internal/PageContentBlock';
import { Columns } from '../../../../internal/Columns';
import ResponsiveImage from '../../../../internal/ResponsiveImage';
import { Link, Button } from '../../../../internal/Button';
import styles from './styles.scss';

type PathwayType = {|
  image: string,
  alt: string,
  href: string,
  title: string,
  description: string,
|};

type PathwaysType = {
  pathways: Array<PathwayType>,
  title: string,
  description: string,
};

const Pathway = (props: PathwayType) => (
  <div>
    <div className={styles.card}>
      <ResponsiveImage
        className={styles.image}
        src={props.image}
        alt={props.alt}
        defaultSize={{ width: 320, height: 200 }}
      />
      <div className={styles.details}>
        <Link className={styles.cardTitle} href={props.href} variant="Underline">
          {props.title}
        </Link>
        <div className={styles.description}>{props.description}</div>
      </div>
    </div>
  </div>
);

export default (props: { featured: PathwaysType, other: PathwaysType }) => {
  const [othersOpen, togglePathways] = React.useState(true);
  if (props.featured.pathways.length === 0) {
    return null;
  }

  return (
    <>
      <PageContentBlock title={props.featured.title} intro={props.featured.description}>
        <Columns columns={3}>
          {props.featured.pathways.map((pathway, index) => (
            /* eslint-disable react/no-array-index-key */
            <Pathway
              key={index}
              image={pathway.image}
              alt={pathway.alt || ''}
              title={pathway.title}
              description={pathway.description}
              href={pathway.href}
            />
            /* eslint-enable react/no-array-index-key */
          ))}
        </Columns>
      </PageContentBlock>
      {othersOpen ? (
        <PageContentBlock layout="Thin" title={props.other.title} intro={props.other.description}>
          <Button
            type="button"
            onClick={() => togglePathways(false)}
            size="Small"
            className={styles.morePathways}
          >
            More
          </Button>
        </PageContentBlock>
      ) : (
        <PageContentBlock>
          <Columns columns={3}>
            {props.other.pathways.map((pathway, index) => (
              /* eslint-disable react/no-array-index-key */
              <Pathway
                key={index}
                image={pathway.image}
                alt={pathway.alt || ''}
                title={pathway.title}
                description={pathway.description}
                href={pathway.href}
              />
              /* eslint-enable react/no-array-index-key */
            ))}
          </Columns>
          <Button
            type="button"
            onClick={() => togglePathways(true)}
            size="Small"
            className={styles.morePathways}
          >
            Less
          </Button>
        </PageContentBlock>
      )}
    </>
  );
};
